import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftEmailSenderServer } from "namirasoft-email-sender";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { EmailSenderLayout } from "./EmailSenderLayout";
import { EmailSenderRoutes } from "./EmailSenderRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ProviderEditPage from "./pages/ProviderEditPage";
import ProviderListPage from "./pages/ProviderListPage";
import ProviderViewPage from "./pages/ProviderViewPage";
import SendPage from "./pages/SendPage";
import SentListPage from "./pages/SentListPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_EMAIL_SENDER}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_EMAIL_SENDER = new EnvService("REACT_APP_BASE_URL_EMAIL_SENDER", true).getString();

            let email_sender = new NamirasoftEmailSenderServer(REACT_APP_BASE_URL_EMAIL_SENDER, result.account.token_manager, result.notifier.onError);

            let servers = { email_sender };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={EmailSenderRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={EmailSenderRoutes.ProviderList} element={<ProviderListPage {...result} servers={servers} />} />
                            <Route path={EmailSenderRoutes.ProviderNew} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={EmailSenderRoutes.ProviderView(":id")} element={<ProviderViewPage {...result} servers={servers} />} />
                            <Route path={EmailSenderRoutes.ProviderEdit(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={EmailSenderRoutes.ProviderCopy(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={EmailSenderRoutes.Verify(":provider_id")} element={<VerifyEmailPage {...result} servers={servers} />} />
                            <Route path={EmailSenderRoutes.Send(null)} element={<SendPage {...result} servers={servers} />} />
                            <Route path={EmailSenderRoutes.Send(":id")} element={<SendPage {...result} servers={servers} />} />

                            <Route path={EmailSenderRoutes.SentList} element={<SentListPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={EmailSenderRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <EmailSenderLayout {...props}>
                {props.children}
            </EmailSenderLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: true
            }
        }}
    />
}

export default Router;